"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsignedDocuments = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("../../../../../constants/routes");
const console_1 = require("../../../../../reducers/slices/console");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const useSearchDebounce_1 = require("../../../../../hooks/useSearchDebounce");
const useInboxPolling_1 = require("../../../../../hooks/useInboxPolling");
const main_1 = require("../../../../../reducers/slices/main");
const delete_document_thunk_1 = require("../../../../../reducers/slices/document/thunks/delete/delete_document_thunk");
const document_overview_thunk_1 = require("../../../../../reducers/slices/document/thunks/document_overview_thunk");
const unsigned_user_documents_thunk_1 = require("../../../../../reducers/slices/document/thunks/unsigned_user_documents_thunk");
const document_status_modal_1 = require("./document_status_modal");
const formatDate_1 = require("../../../../../helpers/formatDate");
const UnsignedDocuments = ({ status }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const [search, setSearch] = (0, useSearchDebounce_1.useSearchDebounce)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { unsignedUserDocuments } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { user } = (0, react_redux_1.useSelector)((state) => state.userState);
    const [sort, setSort] = (0, react_1.useState)({
        key: "date_sort",
        direction: "desc", // Newest first
    });
    // Enable inbox polling for real-time updates
    (0, useInboxPolling_1.useInboxPolling)({ enabled: true });
    (0, react_1.useEffect)(() => {
        dispatch((0, console_1.setPageTitle)("Inbox"));
        dispatch((0, console_1.setShowMenu)(true));
    }, []);
    // Handle row click to show status modal
    const handleRowClick = react_1.default.useCallback((document) => {
        dispatch((0, main_1.setContentModal)({
            title: document.name,
            content: (react_1.default.createElement(document_status_modal_1.DocumentStatusModal, { document: document, onView: () => {
                    dispatch((0, main_1.setContentModal)(null));
                    if ((document === null || document === void 0 ? void 0 : document.status) === "DRAFT") {
                        navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${document === null || document === void 0 ? void 0 : document._id}`);
                    }
                    else {
                        navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${document === null || document === void 0 ? void 0 : document._id}/link`);
                    }
                }, canDelete: document.user_id === (user === null || user === void 0 ? void 0 : user._id), onDelete: () => {
                    dispatch((0, main_1.setContentModal)(null));
                    dispatch((0, main_1.setMessageModal)({
                        title: "Confirm!",
                        messages: [`Are you sure you want to delete document '${document.name}'?`],
                        buttons: [
                            {
                                label: "Cancel",
                                backgroundColor: "bg-white",
                                textColor: "text-primary",
                                borderColor: "border-primary",
                                onClick: () => {
                                    dispatch((0, main_1.setMessageModal)(null));
                                },
                            },
                            {
                                label: "Confirm",
                                onClick: () => {
                                    dispatch((0, delete_document_thunk_1.delete_document_thunk)({
                                        type: "document",
                                        data: { _id: document._id },
                                    })).then((data) => {
                                        if (data.payload) {
                                            dispatch((0, document_overview_thunk_1.document_overview_thunk)());
                                            // Refresh inbox list
                                            if (user === null || user === void 0 ? void 0 : user.email) {
                                                dispatch((0, unsigned_user_documents_thunk_1.unsigned_user_documents_thunk)({ email: user.email }));
                                            }
                                        }
                                    });
                                    dispatch((0, main_1.setMessageModal)(null));
                                },
                            },
                        ],
                    }));
                }, onClose: () => {
                    dispatch((0, main_1.setContentModal)(null));
                } })),
        }));
    }, [dispatch, navigate, user]);
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4 px-2 sm:px-0" },
        react_1.default.createElement("div", { className: "flex justify-end" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { borderColor: "border-borders", backgroundColor: "bg-white", label: "Search", endIcon: pro_light_svg_icons_1.faSearch, value: search, size: "small", onChange: (v) => {
                    setSearch(v);
                } })),
        react_1.default.createElement("div", { className: "flex flex-col gap-8" },
            react_1.default.createElement(doshx_controls_web_1.TableControl, { title: status, columns: [
                    {
                        displayKey: "name",
                        label: "Name",
                    },
                    {
                        displayKey: "sender",
                        label: "Sender",
                    },
                    {
                        displayKey: "signatories",
                        label: "Signatories",
                        formatter: (row) => (react_1.default.createElement("span", { className: "inline-flex items-center justify-center h-6 w-6 rounded-full bg-primary text-white text-xs font-semibold cursor-help", title: row.signatoriesList }, row.signatories)),
                    },
                    {
                        displayKey: "editedDateSort",
                        label: "Edited Date",
                        formatter: (row) => row.editedDate,
                    },
                    {
                        displayKey: "receivedDateSort",
                        label: "Date Received",
                        formatter: (row) => row.receivedDate,
                    },
                ], data: unsignedUserDocuments.map((x) => {
                    // Get sender name from document (multiple sources - same pattern as DocumentStatusModal)
                    const senderName = (() => {
                        // Try document.owner first (populated object from backend)
                        if (x.owner && typeof x.owner === 'object') {
                            const name = `${x.owner.name || ""} ${x.owner.surname || ""}`.trim();
                            return name || x.owner.email || "Document Owner";
                        }
                        // Try document.user_id (populated object from unsigned documents)
                        if (x.user_id && typeof x.user_id === 'object') {
                            const name = `${x.user_id.name || ""} ${x.user_id.surname || ""}`.trim();
                            return name || x.user_id.email || "Document Owner";
                        }
                        // Fallback to current user (should not happen for inbox, but maintaining consistency)
                        if (user) {
                            const name = `${user.name || ""} ${user.surname || ""}`.trim();
                            return name || user.email || "Document Owner";
                        }
                        // Final fallback
                        return "Document Owner";
                    })();
                    // Calculate signatories
                    const signedCount = Array.isArray(x.signers) ? x.signers.filter((s) => s.signed).length : 0;
                    const signersCount = Array.isArray(x.signers) ? x.signers.length : 0;
                    const signatories = x.only_signer ? 1 : Array.isArray(x.signers) && x.signers.length > 0 ? signersCount : 0;
                    // Build signatories list for hover tooltip
                    const signatoriesList = (() => {
                        if (x.only_signer)
                            return "Owner only";
                        if (Array.isArray(x.signers) && x.signers.length > 0) {
                            return x.signers
                                .map((s) => `${s.first_name || ""} ${s.last_name || ""}`.trim() || s.email)
                                .join("\n");
                        }
                        return "No signatories";
                    })();
                    // Edited date
                    const editedDate = (0, formatDate_1.formatDateTime24hr)(x.updatedAt || x.createdAt);
                    const editedDateSort = x.updatedAt ? new Date(x.updatedAt).getTime() : x.createdAt ? new Date(x.createdAt).getTime() : 0;
                    // Received date (when document was sent/received)
                    const receivedDate = (0, formatDate_1.formatDateTime24hr)(x.createdAt);
                    const receivedDateSort = x.createdAt ? new Date(x.createdAt).getTime() : 0;
                    return Object.assign(Object.assign({}, x), { sender: senderName, signatories,
                        signatoriesList,
                        editedDate,
                        editedDateSort,
                        receivedDate,
                        receivedDateSort });
                }), sort: {
                    value: sort,
                    onChange: (newSort) => setSort(newSort),
                }, onRowClicked: handleRowClick }))));
};
exports.UnsignedDocuments = UnsignedDocuments;
